(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opilat-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const accessoryControl = event.target.closest('[data-accessories-slide]');
  if (accessoryControl) {
    const rail = accessoryControl.closest('.op-accessories-catalog').querySelector('.op-product-grid');
    const card = rail.querySelector('.op-product');
    if (!card) return;
    const gap = parseFloat(getComputedStyle(rail).gap) || 0;
    rail.scrollBy({ left: Number(accessoryControl.dataset.accessoriesSlide) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    return;
  }
  const button = event.target.closest('[data-board-src]');
  if (!button) return;
  const gallery = button.closest('[data-board-gallery]');
  const image = gallery.querySelector('.op-board-gallery-image');
  if (!image) return;
  image.srcset = button.dataset.boardSrcset;
  image.src = button.dataset.boardSrc;
  image.alt = button.dataset.boardAlt;
  image.width = Number(button.dataset.boardWidth);
  image.height = Number(button.dataset.boardHeight);
  gallery.querySelectorAll('[data-board-src]').forEach(function(thumb) { thumb.setAttribute('aria-pressed', String(thumb === button)); });
});

  } catch(e) { console.error(e); }
})();
})();
